// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__16JMR","options":"AnswerScale_options__1EQCI","selected":"AnswerScale_selected__3x22r"};